import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import {
  Box,
  Grid,
  Stack,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Dialog,
  Container,
} from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import SubtitleTypographyPrimary from "../../components/typography/SubtitleTypographyPrimary";
import {
  getCityStateFromTemple,
  getTempleName,
  getTempleNameById,
} from "../../utils/HelperFunctions";
import { useEffect, useRef, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Carousel from "react-multi-carousel";

import {
  CAROUSEL_REMOVE_ARRAOW_ON_DEVICE,
  LOCALSTORAGE_KEY,
  PUJA_PACKAGE_SCROLL_RESPONSIVE,
  DEVOTEE_EXPERIENCE_CAROUSEL,
  PUJALOADIMG,
  orderType,
  chadhavaPackageSections,
} from "../../utils/Constants";
import { LOCALIZATION } from "../../utils/localization";
import BannerCarouselWithVideo from "../../components/ServiceInfoDetailsTop/BannerCarouselWithVideo";
import ImageView from "../../components/ImageView/ImageView";
import ChadavaPackageService from "../../components/ServiceInfoDetailsTop/ChadavaPackageService";
import SingleChadavaPackageItem from "../../components/SingleChadavaPackage/SingleChadavaPackageItem";
import ShowMoreShowLess from "../../components/ShowMoreShowLess/ShowMoreShowLess";
import PujaSubscriptionCard from "../../components/pujaSubscriptionCard/PujaSubscriptionCard";
import "../ChadavaPackage/ChadavaPackageDetailsView.scss";
import SubtitleTypography from "../../components/typography/SubtitleTypography";
import ParagraphTypography from "../../components/typography/ParagraphTypography";
import PackageItemsDetailsDialog from "../../components/dialog/PackageItemsDetailsDialog";
import TrustedLogo from "../../components/trustedLogo/TrustedLogo";
import VideoCard from "../../components/card/videoCard/VideoCard";

function ChadavaPackageDetailsView(props: any) {
  const { t, i18n } = useTranslation();
  const tabRefs = useRef<any>({});
  const {
    selectedTempleDetails,
    chadhavaPackageDetails,
    preprocessingAndProceedToAddmemberScreen,
    navigateToSeeVideoView,
    currencySymbols,
    userReview,
    chadhavaPackagePrice,
    chadhavaSubscriptionPrices,
    selectChadhavaPackage,
    isOverseas,
    pujaPriceInfo,
    handleChadhavaPlanChange,
    selectedPlan,
    onClickAddPuja,
    isCountryDisabledForBooking,
    itemAddLimitPopUp,
    setItemAddLimitPopUp,
    isOnlySubscriptionEnable,
    pujaPackagePreviewVideos,
  } = props;

  const [subHeader, setSubHeader] = useState([...chadhavaPackageSections]);
  const [selectedChadhavaitem, setSelectedChadhavaitem] = useState<any>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [
    openAlertDialogForBookingNotAllowed,
    setOpenAlertDialogForBookingNotAllowed,
  ] = useState<any>(false);
  const [activeVideoUrl, setActiveVideoUrl] = useState<number | null>(null);

  useEffect(() => {
    if (chadhavaPackageDetails?.id) {
      let updatedHeader = [...chadhavaPackageSections];

      if (!chadhavaPackageDetails?.isSubscriptionEnable) {
        updatedHeader = updatedHeader.filter(
          (item) =>
            item.id !== "Subscription-Overview" &&
            item.id !== "Subscribe-and-Save"
        );
      } else {
        const hasSubscribeAndSave = updatedHeader.some(
          (item) => item.id === "Subscribe-and-Save"
        );
        if (!hasSubscribeAndSave) {
          updatedHeader.unshift({
            id: "Subscribe-and-Save",
            label: t("Subscribe_and_Save"),
          });
        }

        const hasSubscriptionOverview = updatedHeader.some(
          (item) => item.id === "Subscription-Overview"
        );

        if (!hasSubscriptionOverview) {
          updatedHeader.splice(2, 0, {
            id: "Subscription-Overview",
            label: "Subscription_Overview",
          });
        } else {
          const subIndex = updatedHeader.findIndex(
            (item) => item.id === "Subscription-Overview"
          );
          if (subIndex !== 2) {
            const [subOverview] = updatedHeader.splice(subIndex, 1);
            updatedHeader.splice(2, 0, subOverview);
          }
        }
      }

      const hasPackageDescription =
        !!chadhavaPackageDetails?.packageDescription?.trim();
      const hasPackageImage =
        !!chadhavaPackageDetails?.packageDetailsImage?.pictureUrl;

      const isOnlySubscription = chadhavaPackageDetails?.isOnlySubscription;

      const showPackageOverview =
        !isOnlySubscription && hasPackageDescription && hasPackageImage;

      const hasPackageOverview = updatedHeader.some(
        (item) => item.id === "Package-Overview"
      );

      if (showPackageOverview) {
        if (!hasPackageOverview) {
          updatedHeader.splice(3, 0, {
            id: "Package-Overview",
            label: "Package_Overview",
          });
        } else {
          const pkgIndex = updatedHeader.findIndex(
            (item) => item.id === "Package-Overview"
          );
          if (pkgIndex !== 3) {
            const [pkgOverview] = updatedHeader.splice(pkgIndex, 1);
            updatedHeader.splice(3, 0, pkgOverview);
          }
        }
      } else {
        updatedHeader = updatedHeader.filter(
          (item) => item.id !== "Package-Overview"
        );
      }
      const hasPujaPreviewVideos = pujaPackagePreviewVideos?.length > 0;

      const hasPujaPreviewSection = updatedHeader.some(
        (item) => item.id === "puja-video-preview"
      );
      const faqIndex = updatedHeader.findIndex((item) => item.id === "FAQ");

      if (hasPujaPreviewVideos) {
        if (!hasPujaPreviewSection) {
          const newSection = {
            id: "puja-video-preview",
            label: "The_Temple_Dekho_Promise",
          };
          if (faqIndex !== -1) {
            updatedHeader.splice(faqIndex, 0, newSection);
          } else {
            updatedHeader.push(newSection);
          }
        } else {
          const videoIndex = updatedHeader.findIndex(
            (item) => item.id === "puja-video-preview"
          );

          if (faqIndex !== -1 && videoIndex !== faqIndex - 1) {
            const [videoSection] = updatedHeader.splice(videoIndex, 1);
            updatedHeader.splice(faqIndex, 0, videoSection);
          }
        }
      } else {
        updatedHeader = updatedHeader.filter(
          (item) => item.id !== "puja-video-preview"
        );
      }

      setSubHeader(updatedHeader);
    }
  }, [
    chadhavaPackageDetails?.id,
    chadhavaPackageDetails?.isSubscriptionEnable,
    chadhavaPackageDetails?.packageDescription,
    chadhavaPackageDetails?.packageDetailsImage?.pictureUrl,
    pujaPackagePreviewVideos?.length,
  ]);

  useEffect(() => {
    const buttonId = "back-to-top";
    const hideBackToTop = () => {
      const btn = document.getElementById(buttonId);
      if (btn) {
        btn.style.display = "none";
      }
    };
    const handleScroll = () => {
      hideBackToTop();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      const btn = document.getElementById(buttonId);
      if (btn) {
        btn.style.display = "";
      }
    };
  }, []);

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  const templeName = getTempleName(selectedTempleDetails, savedLanguage);
  const personalInfo = selectedTempleDetails?.personalInfo;
  const templeAddress = getCityStateFromTemple(personalInfo);

  const finalChadhavaPriceAggregated = chadhavaPackagePrice?.finalPrice;
  const offerChadavaPriceAggregated = chadhavaPackagePrice?.offerActualPrice;
  const [urlToShare, setUrlToShare] = useState<string>("");
  const [activeSection, setActiveSection] = useState("aboutPuja");

  useEffect(() => {
    const hostname = window.location.hostname.includes("localhost")
      ? "http://localhost:3000"
      : `https://${window.location.hostname}`;
    if (chadhavaPackageDetails?.id) {
      setUrlToShare(
        `${hostname}/pagelink?chadhavaPackageNameKey=${chadhavaPackageDetails?.pujaNameKey}`
      );
    }
  }, [chadhavaPackageDetails?.id]);

  useEffect(() => {
    if (activeSection && tabRefs.current[activeSection]) {
      tabRefs.current[activeSection].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeSection]);

  useEffect(() => {
    const handleScrollSpy = () => {
      const scrollY = window.scrollY;
      for (let i = 0; i < chadhavaPackageSections.length; i++) {
        const section = document.getElementById(chadhavaPackageSections[i].id);
        if (section) {
          const offsetTop = section.offsetTop - 130;
          const offsetBottom = offsetTop + section.offsetHeight;
          if (scrollY >= offsetTop && scrollY < offsetBottom) {
            setActiveSection(chadhavaPackageSections[i].id);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScrollSpy);
    return () => window.removeEventListener("scroll", handleScrollSpy);
  }, []);

  const pujaBgImage =
    chadhavaPackageDetails &&
    chadhavaPackageDetails.pujaBg &&
    chadhavaPackageDetails.pujaBg.uri
      ? chadhavaPackageDetails.pujaBg.uri
      : PUJALOADIMG;

  const bookPujaPackage = () => {
    if (isCountryDisabledForBooking) {
      setOpenAlertDialogForBookingNotAllowed(true);
      return;
    }
    preprocessingAndProceedToAddmemberScreen();
  };

  const [expanded, setExpanded] = useState<string | false>("panel1");
  const handleChange1 =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const isPujaBookingClosed = () => {
    return !!chadhavaPackageDetails?.isPujaDisable;
  };

  const [isAboveFooter, setIsAboveFooter] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector(".footerArea");
      const button = document.querySelector(".sticky-button");
      if (footer && button) {
        const footerRect = footer.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        if (
          footerRect.top < window.innerHeight &&
          footerRect.bottom >= buttonRect.bottom
        ) {
          setIsAboveFooter(true);
        } else {
          setIsAboveFooter(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      const yOffset = -120; // adjust this based on header height
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
      setActiveSection(id);
    }
  };

  const pujaImageArr =
    chadhavaPackageDetails?.multiPujaImg &&
    chadhavaPackageDetails?.multiPujaImg.length
      ? chadhavaPackageDetails.multiPujaImg.map((_itm: any) => {
          if (_itm?.pictureUrl) {
            return { pictureUrl: _itm.pictureUrl };
          } else if (_itm?.videoUrl) {
            return { videoUrl: _itm.videoUrl };
          } else {
            return { pictureUrl: PUJALOADIMG };
          }
        })
      : [{ pictureUrl: pujaBgImage }];

  const getImageForBenefitsDataByBenefitId = (benefitId: string) => {
    const benefitList = props.benefitsList;
    const benefitFilterData = benefitList.filter(function (item: any) {
      return item.benefitId === benefitId;
    });
    if (benefitList.length > 0) {
      return benefitFilterData[0];
    } else {
      return null;
    }
  };

  const packageList = chadhavaPackageDetails?.packageItems
    ? Object.values(chadhavaPackageDetails?.packageItems)
    : [];

  const templeList = chadhavaPackageDetails?.templeList;

  const handleOpenDialog = (
    pkg: any,
    templeName: any,
    templeAddress: any,
    templeNameKey: any
  ) => {
    setSelectedChadhavaitem({
      ...pkg,
      templeName,
      templeAddress,
      templeNameKey,
    });
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedChadhavaitem(null);
  };

  const isDoubleVideoItem = pujaPackagePreviewVideos?.length <= 2;
  const handleAfterChange = (currentIndex: number) => {
    setActiveVideoUrl(currentIndex);
  };

  return (
    <Box className="pageContainer pujaPage">
      <Box className="pujaBlock">
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            md={2}
            lg={2}
            xl={2}
            className="pagehdLeftBlock"
          ></Grid>
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="pujainfoCenterBlock">
              <Box className="pujaCard">
                <Grid className="pujaCardBlock" container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <BannerCarouselWithVideo imageArray={pujaImageArr || ""} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <ChadavaPackageService
                      pujaName={chadhavaPackageDetails?.pujaName}
                      templeName={templeName}
                      templeAddress={templeAddress}
                      finalPrice={
                        isOverseas
                          ? pujaPriceInfo?.finalPriceOv
                          : pujaPriceInfo?.finalPrice
                      }
                      offerActualPrice={
                        isOverseas
                          ? pujaPriceInfo?.offerActualPriceOv
                          : pujaPriceInfo?.offerActualPrice
                      }
                      itemOrderType={orderType?.puja}
                      urlToShare={urlToShare}
                      tithiName={chadhavaPackageDetails?.tithiName}
                      description={chadhavaPackageDetails?.description}
                      currencySymbols={currencySymbols}
                    />
                  </Grid>
                </Grid>

                <Box
                  className="continueBtn desktopOnly sticky-button"
                  sx={{ position: `${isAboveFooter ? "absolute" : "fixed"}` }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Typography
                        className="pujaPriceText"
                        sx={{ fontWeight: "bold" }}
                      >
                        {currencySymbols}
                        {isOverseas
                          ? pujaPriceInfo?.finalPriceOv ?? 0
                          : pujaPriceInfo?.finalPrice ?? 0}
                      </Typography>

                      {((!isOverseas && pujaPriceInfo?.offerActualPrice) ||
                        (isOverseas && pujaPriceInfo?.offerActualPriceOv)) && (
                        <Typography
                          variant="body2"
                          sx={{
                            textDecoration: "line-through",
                            color: "#E5C765",
                          }}
                        >
                          {currencySymbols}{isOverseas
                            ? pujaPriceInfo?.offerActualPriceOv ?? 0
                            : pujaPriceInfo?.offerActualPrice ?? 0}
                        </Typography>
                      )}
                    </Box>

                    <Button
                      className="desktopContinueBtn"
                      variant="contained"
                      onClick={() => {
                        bookPujaPackage();
                      }}
                      disabled={isPujaBookingClosed()}
                    >
                      {isPujaBookingClosed()
                        ? t(LOCALIZATION.Pooja_Booking_Closed)
                        : t(LOCALIZATION.Continue_to_Book)}
                    </Button>
                  </Stack>
                </Box>
              </Box>

              <Box className="pujaInfoContainer">
                <nav className="pujaTabsNav">
                  <Stack
                    direction="row"
                    spacing={5}
                    className="pujaTabsScroll itemCenter"
                  >
                    {subHeader.map((sec: any) => (
                      <span
                        key={sec.id}
                        className={`pujaTab ${
                          activeSection === sec.id ? "pujaTabActive" : ""
                        }`}
                        onClick={() => handleScrollToSection(sec.id)}
                        ref={(el) => (tabRefs.current[sec.id] = el)}
                      >
                        {t(sec.label)}
                      </span>
                    ))}
                  </Stack>
                </nav>

                <Box
                  className="chadhavaSubscriptionArea"
                  id="Subscribe-and-Save"
                >
                  {chadhavaPackageDetails?.isSubscriptionEnable && (
                    <Box className="chadhavaPlanArea">
                      <SubtitleTypographyPrimary
                        className="planAreaTitle"
                        title={t(LOCALIZATION.Subscribe_and_Save)}
                      ></SubtitleTypographyPrimary>

                      <Box className="planList">
                        {chadhavaPackageDetails?.subscriptions?.map(
                          (plan: any) => {
                            const priceInfo = chadhavaSubscriptionPrices?.[0];

                            return (
                              <PujaSubscriptionCard
                                key={plan?.id}
                                id={plan?.id}
                                name={plan?.name}
                                duration={plan?.frequency}
                                type={plan?.type}
                                description={plan?.description}
                                finalPrice={
                                  isOverseas
                                    ? priceInfo?.finalPriceOv
                                    : priceInfo?.finalPrice || 0
                                }
                                offerActualPrice={
                                  isOverseas
                                    ? priceInfo?.offerActualPriceOv
                                    : priceInfo?.offerActualPrice
                                }
                                currencySymbol={currencySymbols}
                                onSelect={(id: string) =>
                                  handleChadhavaPlanChange(id, priceInfo)
                                }
                                selected={selectedPlan?.id === plan?.id}
                                subscriptionImage={
                                  plan?.subscriptionImage?.pictureUrl || ""
                                }
                                isOnlySubscriptionEnable={
                                  isOnlySubscriptionEnable ?? false
                                }
                              />
                            );
                          }
                        )}
                      </Box>
                    </Box>
                  )}
                  {chadhavaPackageDetails?.isSubscriptionEnable && (
                    <Divider className="divider" />
                  )}

                  <Box
                    className="aboutSubscriptionChadhava"
                    id="Chadava-Package"
                  >
                    <SubtitleTypographyPrimary
                      title={t(
                        LOCALIZATION.Item_Included_In_This_Chadhava_Package
                      )}
                    ></SubtitleTypographyPrimary>
                  </Box>

                  <Box className="productCardCarousel">
                    {packageList?.length > 0 && (
                      <Carousel
                        responsive={PUJA_PACKAGE_SCROLL_RESPONSIVE}
                        swipeable
                        draggable
                        showDots
                        infinite
                        keyBoardControl
                        containerClass="carousel-container"
                        itemClass="carousel-item-padding-40-px"
                        removeArrowOnDeviceType={
                          CAROUSEL_REMOVE_ARRAOW_ON_DEVICE
                        }
                      >
                        {packageList.map((pkg: any) => {
                          const personalInfo =
                            chadhavaPackageDetails?.templeList?.[pkg?.orgId]
                              ?.personalInfo || {};
                          const templeName = getTempleNameById(
                            templeList,
                            pkg?.orgId
                          );
                          const templeNameKey =
                            chadhavaPackageDetails?.templeList?.[pkg?.orgId]
                              ?.nameKey || "";
                          const templeAddress =
                            getCityStateFromTemple(personalInfo);

                          return (
                            <div
                              key={pkg?.id}
                              onClick={() =>
                                handleOpenDialog(
                                  pkg,
                                  templeName,
                                  templeAddress,
                                  templeNameKey
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <SingleChadavaPackageItem
                                packageImage={
                                  pkg?.image?.url || pkg?.image || ""
                                }
                                packageName={pkg?.name}
                                templeName={templeName}
                                templeAddress={templeAddress}
                              />
                            </div>
                          );
                        })}
                      </Carousel>
                    )}
                  </Box>

                  {chadhavaPackageDetails?.isSubscriptionEnable && (
                    <Divider className="divider" />
                  )}

                  {chadhavaPackageDetails?.isSubscriptionEnable && (
                    <Box
                      className="packageDescription"
                      id="Subscription-Overview"
                    >
                      <Box className="mainTitle">
                        <SubtitleTypographyPrimary
                          title={t(LOCALIZATION.Subscription_Overview)}
                        />
                      </Box>

                      <Grid container spacing={2}>
                        {chadhavaPackageDetails?.subscriptions?.map(
                          (subscription: any, index: number) => (
                            <>
                              <Grid item xs={12} md={6}>
                                {subscription?.subscriptionImage
                                  ?.pictureUrl && (
                                  <Box className="packageCardImg">
                                    <ImageView
                                      src={
                                        subscription.subscriptionImage
                                          .pictureUrl || ""
                                      }
                                      alt={`Subscription Image ${index + 1}`}
                                    />
                                  </Box>
                                )}
                              </Grid>

                              <Grid item xs={12} md={6}>
                                {subscription?.description && (
                                  <Box className="bottomDescription">
                                    <ShowMoreShowLess
                                      text={subscription.description}
                                      mode="line"
                                      lines={2}
                                      // limit={200}
                                    />
                                  </Box>
                                )}
                              </Grid>
                            </>
                          )
                        )}
                      </Grid>
                    </Box>
                  )}
                  <Divider className="divider" />
                  {chadhavaPackageDetails?.packageDescription?.trim() &&
                    chadhavaPackageDetails?.packageDetailsImage?.pictureUrl &&
                    !isOnlySubscriptionEnable && (
                      <Box className="packageDescription" id="Package-Overview">
                        <Box className="mainTitle">
                          <SubtitleTypographyPrimary
                            title={t(LOCALIZATION.Package_Overview)}
                          />
                        </Box>

                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6}>
                            {chadhavaPackageDetails?.packageDetailsImage
                              ?.pictureUrl && (
                              <Box className="packageCardImg">
                                <ImageView
                                  src={
                                    chadhavaPackageDetails.packageDetailsImage
                                      .pictureUrl || " "
                                  }
                                  alt="Puja overview Image"
                                />
                              </Box>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            {chadhavaPackageDetails?.packageDescription && (
                              <Box className="bottomDescription">
                                <ShowMoreShowLess
                                  text={
                                    chadhavaPackageDetails.packageDescription
                                  }
                                  limit={200}
                                />
                              </Box>
                            )}
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  {!isOnlySubscriptionEnable &&
                    chadhavaPackageDetails?.packageDescription &&
                    chadhavaPackageDetails?.packageDetailsImage?.pictureUrl && (
                      <Divider className="divider" />
                    )}

                  {chadhavaPackageDetails &&
                    chadhavaPackageDetails.benefitList &&
                    chadhavaPackageDetails.benefitList.length > 0 && (
                      <Box className="pujaBenefits" id="benefit-chadhava">
                        <SubtitleTypographyPrimary
                          title={t(LOCALIZATION.Benefits_of_this_Chadhava)}
                        ></SubtitleTypographyPrimary>
                        {chadhavaPackageDetails &&
                          chadhavaPackageDetails.benefitList &&
                          chadhavaPackageDetails.benefitList.map(
                            (item: any) => {
                              let updatedBenefitsData = item;
                              const benefitDetais =
                                getImageForBenefitsDataByBenefitId(
                                  item.benefitId
                                );

                              if (benefitDetais) {
                                updatedBenefitsData = benefitDetais;
                              }
                              return (
                                <Box
                                  className="benefitsCard"
                                  key={updatedBenefitsData?.name}
                                >
                                  <SubtitleTypography
                                    title={`${updatedBenefitsData.name}`}
                                  ></SubtitleTypography>
                                  <Box className="benefitCardImg">
                                    <ImageView
                                      src={`${updatedBenefitsData.url}`}
                                      alt="Benefit Image"
                                    />
                                  </Box>
                                  <ParagraphTypography
                                    title={`${updatedBenefitsData.description}`}
                                  ></ParagraphTypography>
                                </Box>
                              );
                            }
                          )}
                      </Box>
                    )}

                  <Box className="chadhavaProccessSteps" id="chadhava-steps">
                    <SubtitleTypographyPrimary
                      title={t(LOCALIZATION.chadhava_package_stapes)}
                    ></SubtitleTypographyPrimary>
                    <List>
                      <ListItem>
                        <ListItemText
                          primary={
                            <Box className="listCounter">
                              <Typography
                                component="span"
                                className="pujaStepsListCount"
                              >
                                1
                              </Typography>

                              <Typography>
                                {t(LOCALIZATION.Select_your_Chadhava_Package)}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={
                            <Box className="listCounter">
                              <Typography
                                component="span"
                                className="pujaStepsListCount"
                              >
                                2
                              </Typography>

                              <Typography>
                                {t(LOCALIZATION.Enter_your_details)}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={
                            <Box className="listCounter">
                              <Typography
                                component="span"
                                className="pujaStepsListCount"
                              >
                                3
                              </Typography>

                              <Typography>
                                {t(LOCALIZATION.Make_secure_payment)}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={
                            <Box className="listCounter">
                              <Typography
                                component="span"
                                className="pujaStepsListCount"
                              >
                                4
                              </Typography>

                              <Typography>
                                {" "}
                                {t(LOCALIZATION.Priest_performs_Sankalp)}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          primary={
                            <Box className="listCounter">
                              <Typography
                                component="span"
                                className="pujaStepsListCount"
                              >
                                5
                              </Typography>

                              <Typography>
                                {t(LOCALIZATION.Receive_video_on)}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                    </List>
                  </Box>

                  {pujaPackagePreviewVideos?.length > 0 && (
                    <Box
                      className="pujaVideoPreview carouselArrowColor"
                      id="puja-video-preview"
                    >
                      <SubtitleTypographyPrimary
                        title={t(LOCALIZATION.The_Temple_Dekho_Promise)}
                      />
                      <Typography variant="body1" mt={1}>
                        {t(LOCALIZATION.Promise_Video_Description)}
                      </Typography>

                      <Box mt={3}>
                        {Array.isArray(pujaPackagePreviewVideos) &&
                          pujaPackagePreviewVideos?.length > 0 && (
                            <Carousel
                              responsive={DEVOTEE_EXPERIENCE_CAROUSEL}
                              swipeable
                              draggable
                              showDots
                              keyBoardControl
                              autoPlaySpeed={4000}
                              infinite
                              removeArrowOnDeviceType={
                                CAROUSEL_REMOVE_ARRAOW_ON_DEVICE
                              }
                              className={`pujaVideoCarousel ${
                                isDoubleVideoItem ? "singleItem" : ""
                              }`}
                              afterChange={handleAfterChange}
                              pauseOnHover={false}
                            >
                              {pujaPackagePreviewVideos.map(
                                (video: any, index: number) => (
                                  <VideoCard
                                    key={video?.videoUrl}
                                    videoUrl={video?.videoUrl}
                                    isPlaying={activeVideoUrl === index}
                                    onClickPlay={(isPlay: boolean) => {
                                      if (isPlay) {
                                        setActiveVideoUrl(index);
                                      } else {
                                        setActiveVideoUrl(null);
                                      }
                                    }}
                                    showVideoDescription={
                                      video?.showVideoDescription ?? ""
                                    }
                                  />
                                )
                              )}
                            </Carousel>
                          )}
                      </Box>
                    </Box>
                  )}

                  <Box className="chadhavaFaq" id="faq">
                    <SubtitleTypographyPrimary
                      title={t(LOCALIZATION.Frequently_Asked_Questions)}
                    ></SubtitleTypographyPrimary>

                    <Box className="chadhavaFaqList">
                      <Accordion
                        className="accordionInfo"
                        expanded={expanded === "panel1"}
                        onChange={handleChange1("panel1")}
                        sx={{
                          "&.Mui-expanded::before": {
                            opacity: 1,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color:
                                  expanded === "panel1" ? "#d56939" : "#000",
                                transform:
                                  expanded === "panel1"
                                    ? "rotate(180deg)"
                                    : "rotate(270deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          aria-controls="panel1-content"
                          id="panel1-header"
                          sx={{
                            p: 0,
                            fontWeight: "600",
                          }}
                        >
                          {t(
                            LOCALIZATION.Why_should_I_choose_Temple_Dekho_for_temple_Chadhava
                          )}
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                          {t(
                            LOCALIZATION.Why_should_I_choose_Temple_Dekho_for_temple_ChadhavaAnswer
                          )}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        className="accordionInfo"
                        expanded={expanded === "panel2"}
                        onChange={handleChange1("panel2")}
                        sx={{
                          "&.Mui-expanded::before": {
                            opacity: 1,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color:
                                  expanded === "panel2" ? "#d56939" : "#000",
                                transform:
                                  expanded === "panel2"
                                    ? "rotate(180deg)"
                                    : "rotate(270deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          aria-controls="panel2-content"
                          id="panel2-header"
                          sx={{
                            p: 0,
                            fontWeight: "600",
                          }}
                        >
                          {t(LOCALIZATION.What_is_Chadhava)}
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                          {t(LOCALIZATION.What_is_ChadhavaAnswer)}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        className="accordionInfo"
                        expanded={expanded === "panel3"}
                        onChange={handleChange1("panel3")}
                        sx={{
                          "&.Mui-expanded::before": {
                            opacity: 1,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color:
                                  expanded === "panel3" ? "#d56939" : "#000",
                                transform:
                                  expanded === "panel3"
                                    ? "rotate(180deg)"
                                    : "rotate(270deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          aria-controls="panel3-content"
                          id="panel3-header"
                          sx={{
                            p: 0,
                            fontWeight: "600",
                          }}
                        >
                          {t(LOCALIZATION.Who_designated_to_offer_the_Chadhava)}
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                          {t(
                            LOCALIZATION.Who_designated_to_offer_the_ChadhavaAnswer
                          )}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        className="accordionInfo"
                        expanded={expanded === "panel4"}
                        onChange={handleChange1("panel4")}
                        sx={{
                          "&.Mui-expanded::before": {
                            opacity: 1,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color:
                                  expanded === "panel4" ? "#d56939" : "#000",
                                transform:
                                  expanded === "panel4"
                                    ? "rotate(180deg)"
                                    : "rotate(270deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          aria-controls="panel4-content"
                          id="panel4-header"
                          sx={{
                            p: 0,
                            fontWeight: "600",
                          }}
                        >
                          {t(LOCALIZATION.What_are_the_benefits_of_Chadhava)}
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                          {t(
                            LOCALIZATION.What_are_the_benefits_of_ChadhavaAnswer
                          )}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        className="accordionInfo"
                        expanded={expanded === "panel5"}
                        onChange={handleChange1("panel5")}
                        sx={{
                          "&.Mui-expanded::before": {
                            opacity: 1,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color:
                                  expanded === "panel5" ? "#d56939" : "#000",
                                transform:
                                  expanded === "panel5"
                                    ? "rotate(180deg)"
                                    : "rotate(270deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          aria-controls="panel5-content"
                          id="panel5-header"
                          sx={{
                            p: 0,
                            fontWeight: "600",
                          }}
                        >
                          {t(
                            LOCALIZATION.I_dont_know_my_Gotram_can_I_offer_Chadhava
                          )}
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                          {t(
                            LOCALIZATION.I_dont_know_my_Gotram_can_I_offer_ChadhavaAnswer
                          )}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        className="accordionInfo"
                        expanded={expanded === "panel6"}
                        onChange={handleChange1("panel6")}
                        sx={{
                          "&.Mui-expanded::before": {
                            opacity: 1,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color:
                                  expanded === "panel6" ? "#d56939" : "#000",
                                transform:
                                  expanded === "panel6"
                                    ? "rotate(180deg)"
                                    : "rotate(270deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          aria-controls="panel6-content"
                          id="panel6-header"
                          sx={{
                            p: 0,
                            fontWeight: "600",
                          }}
                        >
                          {t(
                            LOCALIZATION.Could_I_receive_any_proof_of_my_Chadhava
                          )}
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                          {t(
                            LOCALIZATION.Could_I_receive_any_proof_of_my_ChadhavaAnswer
                          )}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        className="accordionInfo"
                        expanded={expanded === "panel7"}
                        onChange={handleChange1("panel7")}
                        sx={{
                          "&.Mui-expanded::before": {
                            opacity: 1,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color:
                                  expanded === "panel7" ? "#d56939" : "#000",
                                transform:
                                  expanded === "panel7"
                                    ? "rotate(180deg)"
                                    : "rotate(270deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          aria-controls="panel7-content"
                          id="panel7-header"
                          sx={{
                            p: 0,
                            fontWeight: "600",
                          }}
                        >
                          {t(
                            LOCALIZATION.Who_should_I_reach_out_to_for_more_information
                          )}
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                          {t(
                            LOCALIZATION.Who_should_I_reach_out_to_for_more_details_FAQ_Answer
                          )}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        className="accordionInfo"
                        expanded={expanded === "panel8"}
                        onChange={handleChange1("panel8")}
                        sx={{
                          "&.Mui-expanded::before": {
                            opacity: 1,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color:
                                  expanded === "panel8" ? "#d56939" : "#000",
                                transform:
                                  expanded === "panel8"
                                    ? "rotate(180deg)"
                                    : "rotate(270deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          aria-controls="panel8-content"
                          id="panel8-header"
                          sx={{
                            p: 0,
                            fontWeight: "600",
                          }}
                        >
                          {t(
                            LOCALIZATION.Can_I_choose_the_temple_and_types_of_chadhava
                          )}
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                          {t(
                            LOCALIZATION.Can_I_choose_the_temple_and_types_of_chadhavaAnswer
                          )}
                        </AccordionDetails>
                      </Accordion>
                      <Accordion
                        className="accordionInfo"
                        expanded={expanded === "panel9"}
                        onChange={handleChange1("panel9")}
                        sx={{
                          "&.Mui-expanded::before": {
                            opacity: 1,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color:
                                  expanded === "panel9" ? "#d56939" : "#000",
                                transform:
                                  expanded === "panel9"
                                    ? "rotate(180deg)"
                                    : "rotate(270deg)",
                                transition: "transform 0.3s ease",
                              }}
                            />
                          }
                          aria-controls="panel9-content"
                          id="panel9-header"
                          sx={{
                            p: 0,
                            fontWeight: "600",
                          }}
                        >
                          {t(
                            LOCALIZATION.How_do_you_ensure_the_security_and_sanctity_of_my_offering
                          )}
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                          {t(
                            LOCALIZATION.How_do_you_ensure_the_security_and_sanctity_of_my_offeringAnswer
                          )}
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            <TrustedLogo />

            <Box className="blessContinue">
              <Box className="continueCart">
                <Box className="continueCenterBlock">
                  <Box display="flex" alignItems="center" gap={2}>
                    <Typography
                      className="pujaPriceText"
                      sx={{ color: "#fff", fontWeight: "bold" }}
                    >
                      {currencySymbols}
                      {isOverseas
                        ? pujaPriceInfo?.finalPriceOv ?? 0
                        : pujaPriceInfo?.finalPrice ?? 0}
                    </Typography>

                    {((!isOverseas && pujaPriceInfo?.offerActualPrice) ||
                      (isOverseas && pujaPriceInfo?.offerActualPriceOv)) && (
                      <Typography
                        variant="body2"
                        sx={{
                          textDecoration: "line-through",
                          color: "#E5C765",
                        }}
                      >
                        {currencySymbols}{" "}
                        {isOverseas
                          ? pujaPriceInfo?.offerActualPriceOv ?? 0
                          : pujaPriceInfo?.offerActualPrice ?? 0}
                      </Typography>
                    )}
                  </Box>
                  <Box className="continueRt">
                    <Button
                      type="button"
                      className="continueBtn"
                      disabled={isPujaBookingClosed()}
                      onClick={() => {
                        bookPujaPackage();
                      }}
                    >
                      {isPujaBookingClosed()
                        ? "Booking Closed"
                        : t(LOCALIZATION.Continue)}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            lg={2}
            xl={2}
            className="pagehdRightBlock"
          ></Grid>
        </Grid>
        <Dialog
          onClose={() => setItemAddLimitPopUp(false)}
          open={itemAddLimitPopUp}
        >
          <Box style={{ padding: "1em" }}>
            <Typography>{t(LOCALIZATION.Cart_Max_Limit_Message)}</Typography>
            <Box sx={{ textAlign: "end" }}>
              <Button onClick={() => setItemAddLimitPopUp(false)}>
                {t(LOCALIZATION.OK)}
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>

      {selectedChadhavaitem?.id && (
        <PackageItemsDetailsDialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          packageImage={selectedChadhavaitem?.image}
          templeName={selectedChadhavaitem?.templeName}
          pujaName={selectedChadhavaitem?.name}
          packageDescription={selectedChadhavaitem?.itemDescription}
          templeAddress={selectedChadhavaitem?.templeAddress}
          onClickAddPuja={() =>
            selectChadhavaPackage({ pujaDetails: selectedChadhavaitem })
          }
        />
      )}
    </Box>
  );
}

export default ChadavaPackageDetailsView;
